export const AGE_BY_STATE = {
  AL: 19,
  NE: 19,
  MS: 21,
};
